var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCakeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.666 10.7656V7.76562M12.666 7.76562C13.7706 7.76562 14.666 6.87019 14.666 5.76562C14.666 4.66106 13.166 2.26562 12.666 2.26562C12.166 2.26562 10.666 4.66106 10.666 5.76562C10.666 6.87019 11.5614 7.76562 12.666 7.76562ZM20.666 15.7656L20.2338 16.4097C19.5009 17.502 17.8807 17.4606 17.2044 16.3324L17.1653 16.267C16.4863 15.1343 14.8451 15.1339 14.1656 16.2663V16.2663C13.4864 17.3984 11.8455 17.398 11.1662 16.266V16.266C10.4868 15.1336 8.84544 15.1332 8.16602 16.2656L8.12607 16.3322C7.44777 17.4627 5.82317 17.5014 5.09187 16.4044L4.66602 15.7656M20.666 21.7656V14.7656C20.666 12.5565 18.8752 10.7656 16.666 10.7656H8.66602C6.45688 10.7656 4.66602 12.5565 4.66602 14.7656V21.7656H20.666Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCakeIcon);
export default __webpack_public_path__ + "static/media/cakeIcon.587937fcb87ed02e58a21f4f4e64bd1e.svg";
export { ForwardRef as ReactComponent };